import { render, staticRenderFns } from "./Base64Upload.vue?vue&type=template&id=bf276f6c"
import script from "./Base64Upload.vue?vue&type=script&lang=js"
export * from "./Base64Upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports